<template>
	<div>
		<div  style="position: relative; width: 100%; height: 300px;">
			<canvas :id="'chart-' + id"></canvas>
		</div>
	</div>
</template>

<script>
	import Chart from 'chart.js/auto'
	import 'chartjs-adapter-date-fns'
	import { fr } from 'date-fns/locale';
	import uniqueId from "lodash.uniqueid";
	import zoomPlugin from 'chartjs-plugin-zoom/dist/chartjs-plugin-zoom.js';

	Chart.register(zoomPlugin);

	export default {
		props: ["chartData"],
		data() {
			return {
				id: uniqueId("")
			}
		},
		mounted() {
			// this.chartData is created in the mixin.
			// If you want to pass options please create a local options object
			this.options = {
				/*plugins: {
					zoom: {
						limits: {
							y: {min: 0}
						},
						pan: {
							enabled: true,
							mode: "x"
						},
						zoom: {
							wheel: {
								enabled: true,
							},
							pinch: {
								enabled: true
							},
							mode: 'x',
						}
					}
				},*/
				responsive: true,
				maintainAspectRatio: false,
				interaction: {
					intersect: false,
				},
				scales: {
					y: {
						beginAtZero: true
					},
					x: {
						type: 'time', // IMPORTANT
						time: {
							unit: 'day', // Tu peux changer : 'minute', 'hour', 'month', etc.
							tooltipFormat: 'PP', // format d'affichage sur le tooltip (date-fns format)
						},
						title: {
							display: true,
							text: 'Date',
						},
						adapters: {
							date: {
								locale: fr // <-- On indique ici la locale française
							}
						},
						ticks: {
							autoSkip: true,
							maxTicksLimit: 10 // maximum de semaines affichées
						},
					},
				}
			}

			var ctx = document.getElementById('chart-' + this.id);
			new Chart(ctx, {
				type: 'bar',
				data: this.chartData,
				options: this.options
			});
		},
	};
</script>